import React from 'react';
import styled from 'styled-components';
import {
  primaryFont, wBold, maxWidth, retina,
} from '../../../Utils/utilsStyle';

type Props = {
  dec: string,
};

const Para = styled.p`
  font-family: ${primaryFont};
  font-weight: ${wBold};
  font-size:16px;
  line-height:20px;
  color:#7E7E7E;
  margin-bottom:30px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size: 12px;
    line-height:14px;
  }
`;

const AlertsDescription = function AlertsDescription(props: Props) {
  const { dec } = props;
  return (
    <Para>{dec}</Para>
  );
};

export default AlertsDescription;
